import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ProposalProjectAffectionDepartment } from "../Model/ProposalProjectAffectionDepartment";

export async function deleteProposalProjectAffectionDepartment(idProposalProject, idDpt) {
    let response = await getAPIResponse("/v1/proposal-project-affectation-department/"+idProposalProject+'/'+idDpt, {} , "DELETE");
    if (response === null) {
        return null;
    }
    let proposalProjectAffectionDepartment = ProposalProjectAffectionDepartment.createFromResponseData(response);
    return proposalProjectAffectionDepartment;
}